/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

import LanguageSwitcher from "../../shared/components/LanguageSwitcher";
import Footer from "../../shared/layouts/AuthLayout/Footer";
import DashboardCard from "./components/DashboardCard";

import GridLayout from "react-grid-layout";

import { Button } from "@material-ui/core";
import workspaceDashboardApi from "../../api/workspaceDashboardApi";
import "./styles.css";

import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import ReactResizeDetector from "react-resize-detector";
import socketIOClient from "socket.io-client";

import { useQuery } from "app/shared/hooks";
import _ from "lodash";
import { useIntl } from "react-intl";
import { decryptKey } from "../../utils/crypto";
import ModalPassword from "./components/Modals/ModalPassword";
import { columns, defaultMinH, rowHeight } from "./constant";
import { getDashboardPassword, storeDashboardPassword } from "./helper";
import useDashboard from "./hooks/useDashboard";
import useWindowSize from "app/shared/hooks/useWindowSizes";

import classes from "./dashboard-public.module.css";

const DashboardPublicV2 = (props) => {
  const intl = useIntl();
  const {
    openPasswordModal,
    history,
    publicSocketRef,
    socketRef,
    items,
    data,
    realTimeData,
    realTimeDataAlarm,
    itemsLoading,
    onPressCtrlKey,
    isFullScreen,
    setRealTimeDataAlarm,
    setRealTimeData,
    allowDragging,
    controlKeyHandler,
    getAllPublicDashboard,
    toggleFullScreen,
    handleCloseModalPassword,
    getAllDashboardView,
    handleResize,
    dashboardView,
    position,
  } = useDashboard({ intl, workspaceDashboardApi });

  const _DASHBOARD_KEY = "key";
  const _PASSWORD_KEY = "p";
  const query = useQuery();

  const renderChildrenCard = () => {
    return _.map(items, (item) => {
      return (
        <div
          className="dashboard-card"
          key={item.id.toString()}
          data-grid={{
            ...position(item?.data?.dashboard_position, item?.type),
            minH: item.minH || defaultMinH,
          }}
        >
          <DashboardCard
            type={item["type"]}
            data={item["data"]}
            loading={itemsLoading[item.id]}
            key={item["id"]}
            dragging={onPressCtrlKey}
            id={item["id"]}
            realTimeData={realTimeData}
            realTimeDataAlarm={realTimeDataAlarm}
            isPublic={true}
            isView={true}
          />
        </div>
      );
    });
  };

  const queryPublicDashboard = (key, password) => {
    handleCloseModalPassword();
    if (key) {
      const dashboardId = decryptKey(key);
      if (dashboardId) {
        getAllPublicDashboard(key, password);
      } else {
        history.replace("/not-found");
      }
    }
  };
  const handleChange = (values) => {
    const password = values?.password;
    const key = query.get(_DASHBOARD_KEY);

    storeDashboardPassword(key, password);
    queryPublicDashboard(key, password);
  };

  useEffect(() => {
    if (dashboardView?.length > 0) {
      handleResize();
      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [dashboardView]);
  useEffect(() => {
    const key = query.get(_DASHBOARD_KEY);
    const password = query.get(_PASSWORD_KEY) || getDashboardPassword(key);

    queryPublicDashboard(key, password);
  }, []);

  useEffect(() => {
    socketRef.current = socketIOClient.io(
      `${process.env.REACT_APP_API_URL}/dashboard-public`,
    );
    publicSocketRef.current = socketIOClient.io(
      `${process.env.REACT_APP_API_URL}/dashboard-alarm-public`,
    );
    return () => {
      socketRef.current.disconnect();
      publicSocketRef.current.disconnect();
    };
  }, []);

  useEffect(() => {
    const socketData = {
      room: data.workspace_id,
    };

    socketRef.current?.emit("join", socketData);
    publicSocketRef.current?.emit("join", socketData);
  }, [data.workspace_id]);

  useEffect(() => {
    socketRef.current?.on("ari-realtime-data", (resp) => {
      setRealTimeData(resp);
    });
    publicSocketRef.current?.on("ari-realtime-data", (resp) => {
      setRealTimeDataAlarm(resp);
    });
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", controlKeyHandler);
    document.addEventListener("keyup", allowDragging);

    return () => {
      document.removeEventListener("keydown", controlKeyHandler);
      document.removeEventListener("keyup", allowDragging);
    };
  }, []);

  useEffect(() => {
    getAllDashboardView();
  }, []);

  return (
    <div className={classes.container} id="dashboard-public">
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          {data?.show_logo && (
            <img src={data?.logo_url} alt="logo" className={classes.logo} />
          )}
        </div>

        <div className={classes.headerRight}>
          <LanguageSwitcher />
          <Button
            style={{ color: "gray" }}
            onClick={() => {
              toggleFullScreen(document.getElementById("dashboard-public"));
            }}
          >
            {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </Button>
        </div>
      </div>

      <div className={classes.body}>
        <ReactResizeDetector
          handleWidth
          handleHeight
          refreshRate="500"
          refreshMode="debounce"
        >
          {({ width, height }) => (
            <GridLayout
              cols={columns}
              rowHeight={rowHeight}
              width={width}
              isResizable={false}
              isDraggable={false}
            >
              {renderChildrenCard()}
            </GridLayout>
          )}
        </ReactResizeDetector>
      </div>

      {data?.show_footer && (
        <div className={classes.footer}>
          <Footer />
        </div>
      )}

      <ModalPassword
        open={openPasswordModal}
        handleClose={handleCloseModalPassword}
        handleChange={handleChange}
      />
    </div>
  );
};

export default DashboardPublicV2;
